import { estUtilisateurOperateur } from "./rolesManager";

// ============================================================
// Périmètre d'un compte d'opérateur d'accompagnement dans le back-office
// (CE-1407) : sa structure (fiche, onglets), le calendrier d'un de ses sites,
// son compte. Tout le reste le renvoie à l'accueil de sa structure. L'API
// refuse de toute façon ce qui n'est pas à lui (403) ; la garde évite d'ouvrir
// des écrans qui ne lui parlent pas (allocataires, EP, utilisateurs Caf).
// ============================================================

export const ACCUEIL_OPERATEUR = "/ma-structure";

const ROUTES_OUVERTES = [
  /^\/ma-structure(\/[a-z-]+)?$/,
  /^\/operateurs\/(?!accompagnement$)[^/]+$/,
  /^\/operateurs\/[^/]+\/comptes\/[^/]+$/,
  /^\/sites\/[^/]+\/calendar$/,
  /^\/me$/,
];

export function estRouteAutoriseePourOperateur(pathname) {
  const chemin = String(pathname || "");
  return ROUTES_OUVERTES.some((motif) => motif.test(chemin));
}

// Chemin vers lequel renvoyer l'utilisateur, ou null s'il peut rester.
export function redirectionPourOperateur(user, pathname) {
  if (!estUtilisateurOperateur(user)) return null;
  return estRouteAutoriseePourOperateur(pathname) ? null : ACCUEIL_OPERATEUR;
}
